<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import { DividerKey } from '$provider/constants/global';

  interface Props {
    item: CommonList & { bgColor?: string; textColor?: string; borderColor?: string };
    onclick?: (item: CommonList & { bgColor?: string; textColor?: string; borderColor?: string }) => void;
  }

  let { item, onclick }: Props = $props();

  let hasCustomStyling = $derived(item.bgColor || item.textColor || item.borderColor);
</script>

<div class="dropdown-list-i">
  {#if item.id === DividerKey}
    <div class="divider">{''}</div>
  {:else}
    <button
      type="button"
      data-cy={`${item.id || item.label}-d`}
      class="item"
      class:has-badge={hasCustomStyling}
      disabled={item.disabled}
      onclick={(e) => { e.stopPropagation(); onclick?.(item); }}
    >
      {#if item.icon}
        <div class="item-icon">
          <Icon value={item.icon} />
        </div>
      {/if}
      <div class="item-label" title={item.label || ''}>
        {#if hasCustomStyling}
          <span class="status-text" style="background: {item.bgColor}; color: {item.textColor}; border: 1px solid {item.borderColor || 'transparent'};">
            {item.label || ''}
          </span>
        {:else}
          {item.label || ''}
        {/if}
      </div>
    </button>
  {/if}
</div>

<style>
  .item {
    display: flex;
    align-items: center;
    text-align: left;
    padding: 12px 16px;
    width: 100%;
    font-weight: 500;
    font-size: 14px;
    color: var(--grey-dark);
    transition: background-color 0.15s ease;
  }
  .item:hover {
    background-color: var(--grey-bg);
  }
  .item .item-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
  }
  .item:disabled {
    cursor: not-allowed;
    background-color: var(--grey-bg);
    opacity: 0.5;
  }
  .item.has-badge {
    padding: 10px 16px;
  }
  .divider {
    width: 100%;
    height: 1px;
    background-color: var(--grey-xlight);
    margin: 4px 0;
  }
  .item-label {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: flex;
    align-items: center;
  }
  .status-text {
    font-size: 0.7rem;
    font-weight: 600;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    white-space: nowrap;
  }
</style>
